import type { Lang } from './i18n';

// Blog topics. Each EN article sets `category: <id>` in its frontmatter; translations
// inherit it from the EN article with the same filename. Order = fallback display order.
export const TOPICS = [
  { id: "training", label: { "en": "Training", "ru": "Тренировки", "de": "Training", "fr": "Entraînement", "es": "Entrenamiento", "pt-BR": "Treino", "ja": "トレーニング", "ko": "트레이닝" } },
  { id: "athletes", label: { "en": "Athletes & Legends", "ru": "Атлеты и легенды", "de": "Athleten & Legenden", "fr": "Athlètes & légendes", "es": "Atletas y leyendas", "pt-BR": "Atletas e lendas", "ja": "選手・レジェンド", "ko": "선수 & 전설" } },
  { id: "the-sport", label: { "en": "The Sport", "ru": "О спорте", "de": "Der Sport", "fr": "Le sport", "es": "El deporte", "pt-BR": "O esporte", "ja": "競技の世界", "ko": "스포츠 이야기" } },
] as const;

export type TopicId = (typeof TOPICS)[number]['id'];
export const TOPIC_IDS: readonly string[] = TOPICS.map((t) => t.id);

export const topicLabel = (id: string, lang: Lang): string =>
  (TOPICS.find((t) => t.id === id)?.label as Record<string, string> | undefined)?.[lang] ?? id;

// Labels for the topic filter on the blog index.
export const topicUi: Record<Lang, { topics: string; all: string; more: string; showing: string }> = {
  "en": { topics: "Topics", all: "All", more: "More topics…", showing: "Showing {n} of {total} posts" },
  "ru": { topics: "Темы", all: "Все", more: "Ещё темы…", showing: "Показано {n} из {total} статей" },
  "de": { topics: "Themen", all: "Alle", more: "Weitere Themen…", showing: "{n} von {total} Artikeln" },
  "fr": { topics: "Sujets", all: "Tous", more: "Plus de sujets…", showing: "{n} articles sur {total}" },
  "es": { topics: "Temas", all: "Todos", more: "Más temas…", showing: "Mostrando {n} de {total} artículos" },
  "pt-BR": { topics: "Temas", all: "Todos", more: "Mais temas…", showing: "Mostrando {n} de {total} artigos" },
  "ja": { topics: "トピック", all: "すべて", more: "その他のトピック…", showing: "{total}件中{n}件を表示" },
  "ko": { topics: "주제", all: "전체", more: "더 많은 주제…", showing: "{total}개 중 {n}개 표시" },
};

/** “Showing 12 of 82 posts” in the page language. */
export const showingText = (lang: Lang, n: number, total: number): string =>
  topicUi[lang].showing.replace('{n}', String(n)).replace('{total}', String(total));
